import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-367579da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body py-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-4 fixHeightScroll"
}
const _hoisted_5 = {
  class: "w-100 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark ms-3" }, " Collection of Minimum KYC Information ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-6 mb-5" }
const _hoisted_11 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_12 = { class: "col-lg-6 mb-5" }
const _hoisted_13 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_14 = { class: "col-lg-6 mb-5" }
const _hoisted_15 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_16 = { class: "col-lg-6 mb-5" }
const _hoisted_17 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_18 = { class: "col-lg-12 mb-5" }
const _hoisted_19 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_20 = { class: "col-6 mb-5" }
const _hoisted_21 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_22 = { class: "col-6 mb-5" }
const _hoisted_23 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_24 = { class: "col-6 mb-5" }
const _hoisted_25 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_26 = { class: "col-6 mb-5" }
const _hoisted_27 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_28 = { class: "col-12 mb-5" }
const _hoisted_29 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_30 = {
  class: "w-100 card verify-card my-5",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_31 = { class: "card-body" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-6 col-lg-2" }
const _hoisted_36 = ["for"]
const _hoisted_37 = { class: "d-block fw-semobold text-start" }
const _hoisted_38 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_39 = { class: "col-6 col-lg-2" }
const _hoisted_40 = ["for"]
const _hoisted_41 = { class: "d-block fw-semobold text-start" }
const _hoisted_42 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_43 = {
  key: 0,
  class: "col-lg-12 mt-10 ms-3"
}
const _hoisted_44 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_45 = {
  class: "w-100 card my-5",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_46 = { class: "card-body" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark ms-3" }, " Verification ")
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-6 mb-5" }
const _hoisted_51 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_52 = { class: "col-lg-6 mb-5" }
const _hoisted_53 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_54 = { class: "col-lg-6 mb-5" }
const _hoisted_55 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_56 = { class: "col-lg-6 mb-5" }
const _hoisted_57 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_58 = {
  class: "w-100 my-5 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_59 = { class: "card-body" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark ms-3" }, " Verification Method ")
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-lg-12 mt-3" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-5 fw-bold text-dark required mb-3 ms-3" }, "Electronic Verification ", -1))
const _hoisted_65 = {
  class: "p-5",
  style: {"border":"1px solid lightgray"}
}
const _hoisted_66 = { class: "d-flex" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ms-3",
  for: "html"
}, "LAB Group", -1))
const _hoisted_68 = { class: "ms-7" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ms-3",
  for: "css"
}, "Data Zoo", -1))
const _hoisted_70 = { class: "ms-7" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ms-3",
  for: "css"
}, "Refinitiv", -1))
const _hoisted_72 = {
  class: "p-5 mt-5",
  style: {"border":"1px solid lightgray"}
}
const _hoisted_73 = { class: "d-flex" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-7" }, [
  /*#__PURE__*/_createTextVNode(" Reliable and independent documentation "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("可靠且独立的文件 ")
], -1))
const _hoisted_75 = { class: "d-flex mt-3" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-7" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" Reliable and independent electronic data from at least two (2) separate data sources "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("来自至少两 (2) 个单独数据源的可靠且独立的电子数据 ")
  ])
], -1))
const _hoisted_77 = { class: "d-flex mt-3" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-7" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" A combination of both of the above "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("上面两者结合 ")
  ])
], -1))
const _hoisted_79 = { class: "col-lg-12 mt-9" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-5 fw-bold text-dark required mb-3 ms-3" }, "Traditional Verification Method", -1))
const _hoisted_81 = {
  class: "p-5",
  style: {"border":"1px solid lightgray"}
}
const _hoisted_82 = { class: "d-flex" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ms-3",
  for: "html"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Verification Method 1:")
], -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-7" }, " Origianl or cerified copy of a primary photographic identification document. ", -1))
const _hoisted_85 = { class: "d-flex mt-3" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ms-3",
  for: "css"
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Verification Method 2:")
], -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-7" }, [
  /*#__PURE__*/_createElementVNode("div", null, " Original or cerified copu of a primary non-photographic identification document; ANS/OR Original or cerified copy of a secondary identification document; ")
], -1))
const _hoisted_88 = {
  class: "w-100 my-5 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_89 = { class: "card-body" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark ms-3" }, " Compliance Note ")
], -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_92 = {
  class: "w-100 my-5 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_93 = { class: "card-body" }
const _hoisted_94 = { class: "d-flex justify-content-center" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Sign and Preview", -1))
const _hoisted_96 = { class: "indicator-progress" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_98 = {
  class: "w-100 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_99 = { class: "card-body" }

import { useStore } from "@/store";
import { useI18n } from "vue-i18n";
import { Field } from "vee-validate";
import { ref, onMounted, computed } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import previewKycForm from "./PreviewKycForm.vue";
import SignatureModal from "./SignatureModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserKycFinalize',
  props: {
    selectedPartyId: {},
    viewFinalize: {}
  },
  emits: ["fetchData", "returnTable"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const store = useStore();





const signatureModalRef = ref<InstanceType<typeof SignatureModal>>();
const loadSigBtn = ref<HTMLButtonElement | null>(null);

const { t } = useI18n();

const isLoading = ref(true);
const kycInfos = ref({} as any);

const trading_exp = computed(() => ({
  exp4: {
    id: "exp4",
    text: t("tip.verificationFinancialAreYouPep"),
    show_more: false,
    more_question: t("tip.yesProvideDetails"),
  },
  exp5: {
    id: "exp5",
    text: t("tip.verificationFinancialAreYouAssociate"),
    show_more: false,
    more_question: t("tip.yesProvideDetails"),
  },
}));

const formatDateToDashFormat = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const loadUserKycInfo = async () => {
  isLoading.value = true;
  loadSigBtn.value?.removeAttribute("data-kt-indicator");

  try {
    // UserService.getKycInfos(props.selectedPartyId);
    kycInfos.value = await UserService.getPredefinedKycInfos(
      props.selectedPartyId
    );
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const complianceDefaultSignature = async () => {
  loadSigBtn.value?.setAttribute("data-kt-indicator", "on");

  try {
    const res = await UserService.getComplianceSignature();
    kycInfos.value.complianceSignature = res;
    kycInfos.value.complianceName = "Victor Ringor";
    kycInfos.value.compliancePosition = "Compliance Officer";
    kycInfos.value.complianceSignedOn = formatDateToDashFormat(new Date());
  } catch (error) {
    MsgPrompt.error(error);
  }
  loadSigBtn.value?.removeAttribute("data-kt-indicator");
};

const handelSignature = (_signature) => {
  kycInfos.value.complianceSignature = _signature;
  signatureModalRef.value?.hide();
  signatureModalRef.value?.clear();
};

const finalizeKycForm = async () => {
  try {
    await UserService.finalizeKycForm(props.selectedPartyId, kycInfos.value);
    MsgPrompt.success(t("tip.submitSuccess")).then(() => {
      emits("fetchData");
    });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const returnTable = () => {
  emits("returnTable");
};

onMounted(async () => {
  await loadUserKycInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { class: "d-flex justify-content-end" }, [
      _createElementVNode("button", {
        class: "btn btn-light btn-success btn-md me-3",
        onClick: returnTable,
        style: {"margin-top":"-65px","height":"45px"}
      }, " Return ")
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!_ctx.viewFinalize)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("fields.firstName")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.firstName,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((kycInfos.value.firstName) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "firstName",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.firstName,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((kycInfos.value.firstName) = $event)),
                              name: "firstName",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("fields.lastName")), 1),
                        _createVNode(_unref(Field), {
                          value: kycInfos.value.lastName,
                          tabindex: "2",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "lastName",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.lastName,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((kycInfos.value.lastName) = $event)),
                              name: "lastName",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("fields.priorName")), 1),
                        _createVNode(_unref(Field), {
                          value: kycInfos.value.priorName,
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "priorName",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.priorName,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((kycInfos.value.priorName) = $event)),
                              name: "priorName",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("fields.birthdate")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.birthday,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((kycInfos.value.birthday) = $event)),
                          tabindex: "4",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "birthday",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: kycInfos.value.birthday,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((kycInfos.value.birthday) = $event)),
                              type: "date",
                              size: "large",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("fields.address")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.address,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((kycInfos.value.address) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "address",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.address,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((kycInfos.value.address) = $event)),
                              name: "address",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("fields.industry")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.industry,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((kycInfos.value.industry) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "industry"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.industry,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((kycInfos.value.industry) = $event)),
                              name: "industry",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "government",
                                  label: _ctx.$t('fields.government')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "accounting",
                                  label: _ctx.$t('fields.accounting')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "banking",
                                  label: _ctx.$t('fields.banking')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "finance",
                                  label: _ctx.$t('fields.finance')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "insurance",
                                  label: _ctx.$t('fields.insurance')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "other",
                                  label: _ctx.$t('fields.other')
                                }, null, 8, ["label"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("fields.position")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.occupation,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((kycInfos.value.occupation) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "occupation"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.occupation,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((kycInfos.value.occupation) = $event)),
                              name: "occupation",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "director",
                                  label: _ctx.$t('fields.director')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "manager",
                                  label: _ctx.$t('fields.manager')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "entry_level",
                                  label: _ctx.$t('fields.entryLevel')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "other",
                                  label: _ctx.$t('fields.other')
                                }, null, 8, ["label"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("fields.annualIncome")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.annualIncome,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((kycInfos.value.annualIncome) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "annualIncome"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.annualIncome,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((kycInfos.value.annualIncome) = $event)),
                              name: "annualIncome",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "1",
                                  label: _ctx.$t('fields.range_1')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "2",
                                  label: _ctx.$t('fields.range_2')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "3",
                                  label: _ctx.$t('fields.range_3')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "4",
                                  label: _ctx.$t('fields.range_4')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "5",
                                  label: _ctx.$t('fields.range_5')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "6",
                                  label: _ctx.$t('fields.range_6')
                                }, null, 8, ["label"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("fields.savingsAndInvestments")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.netWorth,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((kycInfos.value.netWorth) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "netWorth"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.netWorth,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((kycInfos.value.netWorth) = $event)),
                              name: "netWorth",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "1",
                                  label: _ctx.$t('fields.range_1')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "2",
                                  label: _ctx.$t('fields.range_2')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "3",
                                  label: _ctx.$t('fields.range_3')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "4",
                                  label: _ctx.$t('fields.range_4')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "5",
                                  label: _ctx.$t('fields.range_5')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "6",
                                  label: _ctx.$t('fields.range_6')
                                }, null, 8, ["label"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("fields.howToFundTrading")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.sourceOfFunds,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((kycInfos.value.sourceOfFunds) = $event)),
                          tabindex: "2",
                          type: "text",
                          name: "sourceOfFunds",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.sourceOfFunds,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((kycInfos.value.sourceOfFunds) = $event)),
                              tabindex: "2",
                              type: "text",
                              name: "sourceOfFunds",
                              autocomplete: "off",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trading_exp.value, (v_item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "col-lg-12 mb-5"
                        }, [
                          _createElementVNode("label", _hoisted_33, _toDisplayString(v_item.text), 1),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_unref(Field), {
                                modelValue: kycInfos.value[v_item.id],
                                "onUpdate:modelValue": ($event: any) => ((kycInfos.value[v_item.id]) = $event),
                                type: "radio",
                                class: "btn-check",
                                name: v_item.id,
                                value: "0",
                                id: v_item.id + '_true',
                                onClick: ($event: any) => (v_item.show_more = true)
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "id", "onClick"]),
                              _createElementVNode("label", {
                                class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
                                for: v_item.id + '_true'
                              }, [
                                _createElementVNode("span", _hoisted_37, [
                                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("action.yes")), 1)
                                ])
                              ], 8, _hoisted_36)
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_unref(Field), {
                                modelValue: kycInfos.value[v_item.id],
                                "onUpdate:modelValue": ($event: any) => ((kycInfos.value[v_item.id]) = $event),
                                type: "radio",
                                class: "btn-check",
                                name: v_item.id,
                                value: "1",
                                id: v_item.id + '_false',
                                onClick: ($event: any) => (v_item.show_more = false)
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "id", "onClick"]),
                              _createElementVNode("label", {
                                class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
                                for: v_item.id + '_false'
                              }, [
                                _createElementVNode("span", _hoisted_41, [
                                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("action.no")), 1)
                                ])
                              ], 8, _hoisted_40)
                            ])
                          ]),
                          (v_item.show_more || kycInfos.value[v_item.id] == '0')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                _createElementVNode("label", _hoisted_44, _toDisplayString(v_item.more_question), 1),
                                _createVNode(_unref(Field), {
                                  modelValue: kycInfos.value[v_item.id + '_more'],
                                  "onUpdate:modelValue": ($event: any) => ((kycInfos.value[v_item.id + '_more']) = $event),
                                  tabindex: "2",
                                  type: "text",
                                  name: v_item.id + '_more',
                                  autocomplete: "off"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: kycInfos.value[v_item.id + '_more'],
                                      "onUpdate:modelValue": ($event: any) => ((kycInfos.value[v_item.id + '_more']) = $event),
                                      tabindex: "2",
                                      type: "text",
                                      name: v_item.id + '_more',
                                      autocomplete: "off",
                                      size: "large"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _hoisted_48,
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t("fields.formId")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.idType,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((kycInfos.value.idType) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "idType"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.idType,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((kycInfos.value.idType) = $event)),
                              name: "idType",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: 1,
                                  label: "Government ID"
                                }),
                                _createVNode(_component_el_option, {
                                  value: 2,
                                  label: "Driver's License"
                                }),
                                _createVNode(_component_el_option, {
                                  value: 3,
                                  label: "Passport"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t("fields.doc_number")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.idNumber,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((kycInfos.value.idNumber) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "idNumber",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.idNumber,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((kycInfos.value.idNumber) = $event)),
                              name: "idNumber",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t("fields.issue_date")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.idIssuedOn,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((kycInfos.value.idIssuedOn) = $event)),
                          tabindex: "4",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "idIssuedOn",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: kycInfos.value.idIssuedOn,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((kycInfos.value.idIssuedOn) = $event)),
                              type: "date",
                              size: "large",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("fields.expire_date")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.idExpireOn,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((kycInfos.value.idExpireOn) = $event)),
                          tabindex: "4",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "idExpireOn",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: kycInfos.value.idExpireOn,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((kycInfos.value.idExpireOn) = $event)),
                              type: "date",
                              size: "large",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _hoisted_61,
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((kycInfos.value.electronicOrTraditional) = $event)),
                          type: "radio",
                          id: "verifiMethod",
                          name: "electronicOrTraditional",
                          value: "electronic",
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (kycInfos.value.traditionalOption = ''))
                        }, null, 512), [
                          [_vModelRadio, kycInfos.value.electronicOrTraditional]
                        ]),
                        _hoisted_64,
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", null, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((kycInfos.value.electronicSourceOption) = $event)),
                                type: "radio",
                                id: "electronicSourceOption",
                                name: "electronicSourceOption",
                                value: "labGroup"
                              }, null, 512), [
                                [_vModelRadio, kycInfos.value.electronicSourceOption]
                              ]),
                              _hoisted_67
                            ]),
                            _createElementVNode("div", _hoisted_68, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((kycInfos.value.electronicSourceOption) = $event)),
                                type: "radio",
                                id: "electronicSourceOption",
                                name: "electronicSourceOption",
                                value: "dataZoo"
                              }, null, 512), [
                                [_vModelRadio, kycInfos.value.electronicSourceOption]
                              ]),
                              _hoisted_69
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((kycInfos.value.electronicSourceOption) = $event)),
                                type: "radio",
                                id: "electronicSourceOption",
                                name: "electronicSourceOption",
                                value: "refinitiv"
                              }, null, 512), [
                                [_vModelRadio, kycInfos.value.electronicSourceOption]
                              ]),
                              _hoisted_71
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((kycInfos.value.electronicOption) = $event)),
                              type: "radio",
                              id: "electronicOption",
                              name: "electronicOption",
                              value: "0"
                            }, null, 512), [
                              [_vModelRadio, kycInfos.value.electronicOption]
                            ]),
                            _hoisted_74
                          ]),
                          _createElementVNode("div", _hoisted_75, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((kycInfos.value.electronicOption) = $event)),
                              type: "radio",
                              id: "electronicOption",
                              name: "electronicOption",
                              value: "1"
                            }, null, 512), [
                              [_vModelRadio, kycInfos.value.electronicOption]
                            ]),
                            _hoisted_76
                          ]),
                          _createElementVNode("div", _hoisted_77, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((kycInfos.value.electronicOption) = $event)),
                              type: "radio",
                              id: "electronicOption",
                              name: "electronicOption",
                              value: "2"
                            }, null, 512), [
                              [_vModelRadio, kycInfos.value.electronicOption]
                            ]),
                            _hoisted_78
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((kycInfos.value.electronicOrTraditional) = $event)),
                          type: "radio",
                          id: "verifiMethod",
                          name: "electronicOrTraditional",
                          value: "traditional",
                          onClick: _cache[35] || (_cache[35] = ($event: any) => (
                      (kycInfos.value.electronicOption = ''),
                        (kycInfos.value.electronicSourceOption = '')
                    ))
                        }, null, 512), [
                          [_vModelRadio, kycInfos.value.electronicOrTraditional]
                        ]),
                        _hoisted_80,
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((kycInfos.value.traditionalOption) = $event)),
                              type: "radio",
                              id: "traditionalOption",
                              name: "traditionalOption",
                              value: "traditional1"
                            }, null, 512), [
                              [_vModelRadio, kycInfos.value.traditionalOption]
                            ]),
                            _hoisted_83
                          ]),
                          _hoisted_84,
                          _createElementVNode("div", _hoisted_85, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((kycInfos.value.traditionalOption) = $event)),
                              type: "radio",
                              id: "traditionalOption",
                              name: "traditionalOption",
                              value: "traditional2"
                            }, null, 512), [
                              [_vModelRadio, kycInfos.value.traditionalOption]
                            ]),
                            _hoisted_86
                          ]),
                          _hoisted_87
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _hoisted_90,
                    _hoisted_91,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((kycInfos.value.complianceNote) = $event)),
                      id: "w3review",
                      name: "w3review",
                      style: {"width":"100%","height":"150px","padding":"10px"}
                    }, null, 512), [
                      [_vModelText, kycInfos.value.complianceNote]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, [
                      (kycInfos.value.complianceSignature == '')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            ref_key: "loadSigBtn",
                            ref: loadSigBtn,
                            class: "btn btn-light btn-success btn-lg me-3",
                            onClick: complianceDefaultSignature
                          }, [
                            _hoisted_95,
                            _createElementVNode("span", _hoisted_96, [
                              _createTextVNode(_toDisplayString(_ctx.$t("action.pleaseWait")) + " ", 1),
                              _hoisted_97
                            ])
                          ], 512))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-light btn-primary btn-lg me-3",
                            onClick: finalizeKycForm
                          }, " Submit "))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["fixHeightScroll", _ctx.viewFinalize ? 'col-12' : 'col-8'])
          }, [
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("div", _hoisted_99, [
                _createVNode(previewKycForm, { kycInfos: kycInfos.value }, null, 8, ["kycInfos"])
              ])
            ])
          ], 2)
        ])
      ]),
      _createVNode(SignatureModal, {
        ref_key: "signatureModalRef",
        ref: signatureModalRef,
        onHandelSignature: handelSignature
      }, null, 512)
    ])
  ], 64))
}
}

})